import Vue from 'vue'
import VueMeta from 'vue-meta'
import { plugin } from '@inertiajs/inertia-vue'
import PortalVue from 'portal-vue' 
import VSelect from 'vue-select'
import Toasted from 'vue-toasted' 
import VCalendar from 'v-calendar'
import VModal from 'vue-js-modal' 
import Draggable from 'vuedraggable'
import VueTippy, { TippyComponent } from 'vue-tippy'
import VueTextareaAutosize from 'vue-textarea-autosize'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueClipboard from 'vue-clipboard2'
import Nl2br from 'vue-nl2br'
import VStickyElement from 'vue-sticky-element'
import VueScrollTo from 'vue-scrollto'
import VueSanitize from "vue-sanitize"


// Plugins
Vue.use(PortalVue)
Vue.use(VueMeta)
Vue.use(Toasted)
Vue.use(plugin)
Vue.use(VCalendar)
Vue.use(BootstrapVue)
Vue.use(VueAwesomeSwiper)
Vue.use(BootstrapVue)
Vue.use(VueTippy)
Vue.use(VueScrollTo)
Vue.use(VStickyElement)
Vue.use(VueTextareaAutosize)
Vue.use(VueSanitize)
Vue.use(VModal, { dynamic: true })


// Components
Vue.component('nl2br', Nl2br)
Vue.component('draggable', Draggable);
Vue.component('v-select', VSelect);
Vue.component("tippy", TippyComponent);
Vue.component("sticky-element", VStickyElement);
Vue.component('loader', require('@back.components/Loader').default);
Vue.component('loading-button', require('@back.components/form/LoadingButton').default);
Vue.component('modal', require('@components/Modal').default);
Vue.component('card', require('@components/Card').default);
Vue.component('app-header', require('@partials/Header').default);
Vue.component('app-footer', require('@partials/Footer').default);

// Form
Vue.component('form-component', require('@components/forms/Form').default);
Vue.component('form-progress', require('@components/forms/partials/Progress').default);
Vue.component('form-feedback', require('@components/forms/partials/Feedback').default);
Vue.component('form-row', require('@components/forms/partials/Row').default);
Vue.component('form-section', require('@components/forms/partials/Section').default);

// Form elements
Vue.component('form-label', require('@components/form-elements/Label').default);
Vue.component('form-errors', require('@components/form-elements/Errors').default);
Vue.component('input-group', require('@components/form-elements/InputGroup').default);
Vue.component('input-text', require('@components/form-elements/InputText').default);
Vue.component('input-file', require('@components/form-elements/InputFile').default);
Vue.component('input-textarea', require('@components/form-elements/InputTextarea').default);
Vue.component('input-date', require('@components/form-elements/InputDate').default);
Vue.component('input-select', require('@components/form-elements/InputSelect').default);
Vue.component('input-datalist', require('@components/form-elements/InputDatalist').default);
Vue.component('input-radio', require('@components/form-elements/InputRadio').default);
Vue.component('input-grid', require('@components/form-elements/InputGrid').default);
Vue.component('input-place', require('@components/form-elements/InputPlace').default);
Vue.component('checkbox', require('@components/form-elements/Checkbox').default);
Vue.component('checkboxes', require('@components/form-elements/Checkboxes').default);

// VSelect
VSelect.props.components.default = () => ({
	Deselect: {
		render: createElement => createElement('i', {class: 'bi bi-x'})
	},
	OpenIndicator: {
		render: createElement => createElement('i', {class: 'bi bi-chevron-down'})
	}
});


// Flash

Vue.prototype.$flash = function(payload) {
    setTimeout(() => { 
        this.$toasted.show(payload, {
            position: 'bottom-right', 
            duration: 2500
        })
    }, 400)
}